import { styled } from '@mui/material/styles';
import { ListItemButton } from '@mui/material';
import { grey } from '@mui/material/colors';

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
	margin: '3px 10px',
	WebkitTapHighlightColor: 'transparent',
	outline: '0px',
	border: '0px',
	cursor: 'pointer',
	userSelect: 'none',
	verticalAlign: 'middle',
	appearance: 'none',
	display: 'flex',
	WebkitBoxFlex: '1',
	flexGrow: '1',
	WebkitBoxPack: 'start',
	justifyContent: 'flex - start',
	WebkitBoxAlign: 'center',
	alignItems: 'center',
	textDecoration: 'none',
	minWidth: '0px',
	boxSizing: 'border - box',
	textAlign: 'left',
	padding: '8px 12px 8px 16px',
	transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
	position: 'relative',
	textTransform: 'capitalize',
	borderRadius: '8px',
	height: '36px',

	'&.Mui-selected': {
		backgroundColor:
			theme.palette.mode === 'light' ? 'rgba(19,66,111,0.08)' : 'rgba(19,66,111,0.58)',
		color: theme.palette.mode === 'light' ? 'rgba(19,66,111,1)' : grey[100],
		'& .MuiListItemIcon-root': {
			color: 'white'
		}
	},

	'&:hover': {
		backgroundColor:
			theme.palette.mode === 'light' ? 'rgba(19,66,111,0.08)' : 'rgba(19,66,111,0.58)',
		color: theme.palette.mode === 'light' ? 'rgba(19,66,111,1)' : grey[100],
		'& .MuiListItemIcon-root': {
			color: 'white'
		}
	}
	// '&$selected': {
	// 	backgroundColor: 'red',
	// 	color: 'white',
	// 	'& .MuiListItemIcon-root': {
	// 		color: 'white'
	// 	}
	// },
	// '&$selected:hover': {
	// 	backgroundColor: 'purple',
	// 	color: 'white',
	// 	'& .MuiListItemIcon-root': {
	// 		color: 'white'
	// 	}
	// }
	// '&:hover': {
	// 	backgroundColor: 'blue',
	// 	color: 'white',
	// 	'& .MuiListItemIcon-root': {
	// 		color: 'white'
	// 	}
	// }
}));
